function SvgChartSquare(props, { color = "#9747FF", width = 20, height = 20 }) {
  const { color: iconColor, ...restProps } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M8.42394 9.29102H6.21561C5.69061 9.29102 5.26562 9.71598 5.26562 10.241V14.5076H8.42394V9.29102V9.29102Z"
        stroke={iconColor || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6346 5.5H9.36796C8.84296 5.5 8.41797 5.92501 8.41797 6.45001V14.5H11.5763V6.45001C11.5763 5.92501 11.1596 5.5 10.6346 5.5Z"
        stroke={iconColor || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7904 10.709H11.582V14.5007H14.7404V11.659C14.732 11.134 14.307 10.709 13.7904 10.709Z"
        stroke={iconColor || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5013 18.3327H12.5013C16.668 18.3327 18.3346 16.666 18.3346 12.4993V7.49935C18.3346 3.33268 16.668 1.66602 12.5013 1.66602H7.5013C3.33464 1.66602 1.66797 3.33268 1.66797 7.49935V12.4993C1.66797 16.666 3.33464 18.3327 7.5013 18.3327Z"
        stroke={iconColor || color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgChartSquare;
